import React, { useState } from "react";
import { Field } from "redux-form";
import { useDispatch, useSelector } from "react-redux";
import { email, required } from "redux-form-validators";
import { makeProfileData } from "../../../actions/storage";

import { showToast } from "../../../helpers/notify";
import Logout from "./Logout";
import ProfileCard from "./ProfileCard";
import MySavedList from "../MySavedList";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";
import NoMatch from "../../../components/NoMatch";
import Button from "../../../components/Field/Button";
import AsyncForm from "../../../components/AsyncForm";
import DialogBox from "../../../components/DialogBox";
import Input from "../../../components/Field/Input/Input";
import MarketingPreferences from "./MarketingPreferences";
import ManagePaymentMethod from "./MembershipDetails/ManagePaymentMethod";
import CancelMembership from "../../../components/DialogBox/CancelMembership";

import style from "./style.module.css";
import AsyncGet from "../../../components/AsyncGet";

export default function MyProfile(props) {
    const {
        marketing_preferences_link = ""
    } = props;
    const dispatch = useDispatch();
    const userProfile = useSelector((state) => state.storage.data);
    let getUser = {};
    const [popup, setPopup] = useState(false);

    return (
        userProfile.id !== undefined ? (
            <AsyncGet
                id="getProfile"
                url="/account"
                permissionText={false}
                loadOnMount={true}
                showToastOnError={false}
                render={({ data }) => {
                    getUser = data;
                    return (
                        <>
                            <Section className={style.myProfile}>
                                <div className={style.sectionRow}>
                                    <div className={style.sectionHeader}>
                                        <div className={style.colRow}>
                                            <Title className="fontTeko" transform="uppercase" tag="h4">My Profile</Title>
                                            <Logout />
                                        </div>
                                        <Spacer size="65" />
                                    </div>
                                    <div className={style.sectionBody}>
                                        <Spacer size="65" />
                                        <AsyncForm
                                            id="profileupdate"
                                            url="/account/update"
                                            permissionText="Update"
                                            type="update"
                                            hasGetAction={false}
                                            showToastOnSuccess={false}
                                            onSave={({ data }) => {
                                                if (data.id && data.member_rating === undefined) {
                                                    showToast("Profile was updated successfully");
                                                    dispatch(makeProfileData(data));
                                                }
                                            }}
                                            changeFormValuesBeforeSubmit={({ id, ...rest }) => {
                                                return rest;
                                            }}
                                            initialValues={
                                                {
                                                    email: userProfile.email,
                                                    first_name: userProfile.first_name,
                                                    surname: userProfile.surname,
                                                    interests: userProfile.interests,
                                                }
                                            }
                                            render={({ fetching }) => (
                                                <>
                                                    <div className={`${style.colRow} ${style.sectionItem}`}>
                                                        <div className={style.titleContent}>
                                                            <Title className="fontTeko" transform="uppercase" tag="h4">Personal details</Title>
                                                        </div>
                                                        <div className={style.formContent}>
                                                            <ProfileCard />
                                                            <Spacer size="24" />
                                                            <div className={style.formWrap}>
                                                                <div className={style.form}>
                                                                    <div className={style.formRow}>
                                                                        <Field
                                                                            name="first_name"
                                                                            component={Input}
                                                                            validate={required()}
                                                                            required={true}
                                                                            placeholder="Enter your first name"
                                                                            label="First name"
                                                                        />
                                                                    </div>
                                                                    <div className={style.formRow}>
                                                                        <Field
                                                                            name="surname"
                                                                            component={Input}
                                                                            validate={required()}
                                                                            required={true}
                                                                            placeholder="Enter your last name"
                                                                            label="Last name"
                                                                        />
                                                                    </div>
                                                                    <div className={style.formRow}>
                                                                        <Field
                                                                            name="email"
                                                                            component={Input}
                                                                            validate={[required(), email()]}
                                                                            required={true}
                                                                            placeholder="Enter your email address"
                                                                            label="Email address"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <Spacer size="65" />
                                                                <div className={`${style.formRow} ${style.formSubmit}`}>
                                                                    <div className={style.colRow}>
                                                                        <Button
                                                                            submit={true}
                                                                            color="buttonPrimary"
                                                                            fetching={fetching}
                                                                            label="UPDATE"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <Spacer size="65" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ManagePaymentMethod
                                                        userProfile={getUser}
                                                    />
                                                    <MarketingPreferences
                                                        userProfile={getUser}
                                                        marketingPreferencesLink={marketing_preferences_link}
                                                    />
                                                    <div className={style.savedList}>
                                                        <MySavedList title="My Saved List" />
                                                    </div>
                                                </>
                                            )}
                                        />
                                    </div>
                                </div>
                            </Section>
                            {
                                popup === "cancel_membership" && (
                                    <DialogBox
                                        onClose={() => setPopup(false)}
                                        className={`${style.articlePopup}`}
                                        title={false}
                                        headerClass={style.dialogBoxHeader}
                                        modalClassName={style.articleModal}
                                        buttonClassName={style.customCloseStyle}
                                        hasCloseIcon={false}
                                        render={({ closeDialog }) => (
                                            <CancelMembership closeDialog={closeDialog} />
                                        )}
                                    />
                                )
                            }
                        </>
                    )
                }
                }
            />
        ) : (
            <NoMatch
                title="Please Login"
                text="Lorem ipsum dolor sit amet consectetur."
                label="Goto Sign in"
                link="/sign-in"
            />
        )
    );
}
